import { styled } from "@mui/material/styles";
import { Box, TextField, FormControl, Button } from "@mui/material";

export const FilterContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 10px;
`;

export const InputBox = styled(TextField)`
  margin-right: 10px;
`;

export const InputSearch = styled(FormControl)`
  margin-right: 10px;
`;

export const ButtonComponent = styled(Box)`
  margin-bottom: 20px;
`;

export const ResetButton = styled(Button)`
  margin-right: 20px;
`;

export const FieldWrapper = styled(Box)({
  width: "33%",
});
